module.exports = __webpack_public_path__ + "static/qardan-hasana-illustration-1f93979f608a8757e26e7699f082a6e9.png";